import React from 'react';
import './Faculty.css';

const Faculty = () => {
  const facultyData = [
    { id: 1, name: "Chitra Subramanian", designation: "Principal", qualification: "M.A (Eng), B.Ed, Ph.D", experience: "35" },
    { id: 2, name: "Vaishnavi Dhage", designation: "Admin Head", qualification: "D.C. Sc & Eng", experience: "08" },
    { id: 3, name: "Vani V", designation: "NTT", qualification: "NTTC", experience: "05" },
    { id: 4, name: "Nirmala", designation: "NTT", qualification: "NTTC", experience: "02" },
    { id: 5, name: "Lakshmidevi V", designation: "PRT", qualification: "B.A, D.Ed", experience: "10" },
    { id: 6, name: "Rohini N", designation: "PRT", qualification: "B.A, B.Ed", experience: "06" },
    { id: 7, name: "Shilpa T", designation: "PRT", qualification: "B.A, D.Ed", experience: "03" },
    { id: 8, name: "Reshma A R", designation: "PRT", qualification: "M.Com", experience: "07" },
    { id: 9, name: "Swathi C N", designation: "PRT", qualification: "M.Com", experience: "03" },
    { id: 10, name: "Aruna E", designation: "Computer", qualification: "B.E", experience: "03" },
    { id: 11, name: "Kavya Y", designation: "PRT", qualification: "B.Com", experience: "07" },
    { id: 12, name: "Chandana N", designation: "Grievance Officer", qualification: "B.Com", experience: "02" },
    { id: 13, name: "Nayanashree", designation: "Computer", qualification: "B.E", experience: "03" },
    { id: 14, name: "Bhavani C", designation: "PRT", qualification: "B.Com", experience: "02" },
    { id: 15, name: "Shobha", designation: "Music Teacher", qualification: "B.A", experience: "02" },
    { id: 16, name: "Basavaraja E", designation: "TGT", qualification: "B.A, B.Ed", experience: "10" },
    { id: 17, name: "Manjula B", designation: "TGT", qualification: "B.A, B.Ed", experience: "05" },
    { id: 18, name: "Neha Begum", designation: "TGT", qualification: "B.Sc, B.Ed", experience: "02" },
    { id: 19, name: "Megha P. B", designation: "TGT", qualification: "B.A, B.Ed (Hindi)", experience: "03" },
    { id: 20, name: "Hemavathi K", designation: "TGT", qualification: "B.A, B.Ed", experience: "01" },
    { id: 21, name: "Shivamala D R", designation: "TGT", qualification: "M.A, B.Ed", experience: "10" },
    { id: 22, name: "Kokila", designation: "TGT", qualification: "M.A, B.Ed", experience: "03" },
    { id: 23, name: "Rashmi T", designation: "TGT", qualification: "M.Sc, D.Ed", experience: "04" },
    { id: 24, name: "Revathy", designation: "TGT", qualification: "M.A, B.Ed", experience: "02" },
    { id: 25, name: "Bosaiah B", designation: "PET", qualification: "M.P.Ed", experience: "02" },
    { id: 26, name: "Malini John", designation: "Counsellor / Special Educator", qualification: "M.A (Eng)", experience: "06" },
    { id: 27, name: "Mahalakshmi", designation: "Wellness Incharge", qualification: "B.Sc Nursing", experience: "10" },
    { id: 28, name: "B. Thippeswamy", designation: "Librarian", qualification: "B.Sc, D.Lib", experience: "30" },
    { id: 29, name: "Bhoomika V S", designation: "Dance Teacher", qualification: "Para Medical", experience: "01" },
    { id: 30, name: "Tintu Devasi", designation: "PRT", qualification: "MSW", experience: "01" },
    { id: 31, name: "Veeresh E", designation: "Drawing Teacher", qualification: "F.C.B.V.A", experience: "01" },
    { id: 32, name: "Sinchana P M", designation: "TGT", qualification: "M.Sc, M.Ed", experience: "01" },
    { id: 33, name: "Salma", designation: "PRT", qualification: "B.Com", experience: "01" },
    { id: 34, name: "Jyothis Paul", designation: "PRT", qualification: "B.Ed, M.A (Eng)", experience: "01" },
    { id: 35, name: "Jayanth N", designation: "Drawing Teacher", qualification: "P.D.B.V.A", experience: "01" },
    { id: 36, name: "Akshara Dinesh", designation: "PRT", qualification: "M.A (Eng)", experience: "01" },
    { id: 37, name: "Rajeshwari", designation: "PRT", qualification: "B.A, B.Ed", experience: "01" },
    { id: 38, name: "E Sahana", designation: "PRT", qualification: "B.Sc, B.Ed", experience: "01" },
    { id: 39, name: "Thaseena J", designation: "PRT", qualification: "M.Sc, B.Ed", experience: "01" },
    { id: 40, name: "Swathi M", designation: "PRT", qualification: "M.Sc (Che)", experience: "01" },
    { id: 41, name: "Alex M Shepherd", designation: "TGT", qualification: "B.Sc, B.Ed", experience: "01" },
    { id: 42, name: "Ritu Arya", designation: "TGT", qualification: "M.Sc, B.Ed", experience: "01" },
    { id: 43, name: "Madhushree", designation: "TGT", qualification: "M.A, B.Ed", experience: "01" },
    { id: 44, name: "Divyajyothi", designation: "TGT", qualification: "M.Sc, B.Ed", experience: "01" },
    { id: 45, name: "Ragini", designation: "TGT", qualification: "M.Sc, B.Ed", experience: "01" },
  ];

  return (
    <main className="faculty-page">
      <div className="faculty-container">
        <div className="faculty-header">
          <h1>Our Faculty</h1>
          <p>Meet our dedicated team of educators and staff</p>
        </div>

        <div className="table-wrapper">
          <table className="faculty-table">
            <thead>
              <tr>
                <th>Sl. No</th>
                <th>Name of Teacher/Staff</th>
                <th>Designation</th>
                <th>Qualification</th>
                <th>Experience (Yrs)</th>
              </tr>
            </thead>
            <tbody>
              {facultyData.map((staff, index) => (
                <tr key={`${staff.name}-${index}`}>
                  <td className="sl-no">{index + 1}</td>
                  <td className="name">{staff.name}</td>
                  <td className="designation">{staff.designation}</td>
                  <td className="qualification">{staff.qualification}</td>
                  <td className="experience">{staff.experience}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </main>
  );
};

export default Faculty;
